/* esm.sh - tailwindcss-animate@1.0.7 */
export * from "/*tailwindcss-animate@1.0.7/esnext/tailwindcss-animate.mjs";
export { default } from "/*tailwindcss-animate@1.0.7/esnext/tailwindcss-animate.mjs";
